<template>
  <div class="pointer-events-none absolute bottom-0 right-0 flex size-full flex-col justify-between px-8 pb-8">
    <div class="mt-1 flex">
      <ui-list-date-selector-tab
        v-show="hazardsStore.activeView === HazardView.Map && hazardsStore.mapMode !== MapMode.Default && showDateSelector"
        class="pointer-events-auto rounded bg-white px-2 py-1"
      />
    </div>
    <div class="flex w-full items-end justify-between">
      <ui-map-control-layers />
      <div class="flex flex-row items-end gap-2">
        <div class="flex flex-col items-end gap-2">
          <gv-tooltip
            :label="zoomOutTooltipLabel"
            :floating-ui-options="{
              offset: 16,
              placement: 'left',
            }"
          >
            <ui-map-control-button :icon="{ name: 'open_in_full' }" aria-label="Zoom out to see full map of the state" @click="fitBounds" />
          </gv-tooltip>
          <ui-map-control-zoom />
          <ui-map-control-pan />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { showDateSelector } from '@/common';
import { HazardView, MapMode, WESTERN_AUSTRALIA_BOUNDING_BOX, useHazardsStore, useMapStore } from '@/features/hazards';

const map = useMapStore();
const hazardsStore = useHazardsStore();

const fitBounds = () => {
  map.setViewPort(WESTERN_AUSTRALIA_BOUNDING_BOX);
};

const zoomOutTooltipLabel = 'Zoom out to see the\nfull map of the state';
</script>
